import React, { useEffect, useState } from 'react';
import '../assets/css/FAQ.css';
import '../assets/css/Loader.css';  // Import du fichier CSS pour le loader
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/config';

function FAQSection() {
    const [openIndex, setOpenIndex] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        fetch(`${API_BASE_URL}/faq/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const additionalQuestions = [
                    {
                        question: "Comment devenir bénévole dans votre association ?",
                        reponse: (
                            <>
                                Pour devenir bénévole, vous pouvez remplir un <Link to="/nous-rejoindre">formulaire de contact</Link> disponible sur notre site. Aucune compétence préalable n’est nécessaire, nous vous formons.
                            </>
                        ),
                    },
                    {
                        question: "Comment demander un dispositif prévisionnel de secours pour un événement ?",
                        reponse: (
                            <>
                                Vous trouverez les informations nécessaires via notre <Link to="/nous-contacter">formulaire en ligne</Link>.
                            </>
                        ),
                    },
                    {
                        question: "Je ne trouve pas ma question. Comment puis-je obtenir plus d'informations ?",
                        reponse: (
                            <>
                                Si votre question ne figure pas ici, vous pouvez nous <Link to="/nous-contacter">contacter via notre formulaire en ligne</Link>. Nous nous ferons un plaisir de vous répondre rapidement.
                            </>
                        ),
                    }
                ];                
                setQuestions([...data, ...additionalQuestions]);
                setLoading(false);  // Données chargées
            })
            .catch((error) => {
                console.error('Erreur lors de la récupération des FAQ:', error);
                setLoading(false);  // Fin du chargement même en cas d'erreur
            });
    }, []);

    return (
        <section className="faq-section container my-5">
            <h2 className="section-title">FAQ</h2>

            {loading ? (
                <div className="faq-loader">
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="faq-placeholder">
                            <div className="faq-placeholder-line">
                                <span className="faq-placeholder-icon"></span>
                                <span className="faq-placeholder-question"></span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="faq-items">
                    {questions.map((question, index) => (
                        <div
                            key={index}
                            className={`faq-item ${openIndex === index ? 'open' : ''}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-question">
                                <span className="faq-icon">{openIndex === index ? '-' : '+'}</span>
                                {question.question}
                            </div>
                            <div className="faq-answer">
                                {question.reponse}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
}

export default FAQSection;
